import { render } from "./select-parcels.vue?vue&type=template&id=a8fe4fea"
import script from "./select-parcels.vue?vue&type=script&lang=js"
export * from "./select-parcels.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__